'use client';

const TypographySection = () => {
  return (
    <section className="my-12">
      {/* Title Section */}
      <h1 className="text-2xl sm:text-3xl xl:text-4xl text-[--accent-light] my-4">
        Typography
      </h1>

      <p className="text-xl font-bold mb-2 mx-6">
        Defining the Centera Tech Voice
      </p>

      <div className="m-6 p-6 border border-color-97 rounded-lg">
        <h3 className="text-xl font-bold text-[--secondary-text]">
          Font Style
        </h3>
        <p className="text-3xl sm:text-4xl lg:text-5xl font-semibold my-2 text-[--primary-text]">
          Urbanist
        </p>
        <p className="text-color-2">
          A modern, clean, and professional sans-serif typeface.
        </p>
      </div>

      {/* Typography Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mt-6 sm:mt-8 mx-6">
        {[
          {
            name: "Heading 1",
            example: "Centera Tech",
            className: "text-4xl lg:text-6xl font-semibold",
          },
          {
            name: "Heading 2",
            example: "Pioneering Digital Solutions",
            className: "text-2xl sm:text-3xl xl:text-4xl text-[--accent-light]",
          },
          {
            name: "Heading 3",
            example: "Our Mission & Vision",
            className: "text-3xl lg:text-4xl font-medium",
          },
          {
            name: "Body Text",
            example:
              "At Centera Tech, we craft innovative software solutions to drive business success.",
            className: "text-base sm:text-lg text-color-2",
          },
          {
            name: "Caption",
            example: "Empowering businesses through technology.",
            className: "text-sm sm:text-base text-color-2",
          },
        ].map((typo, index) => (
          <div
            key={index}
            className="flex flex-col gap-2 p-4 border border-color-97 rounded-lg"
          >
            <h3 className="text-xl font-bold text-color-2">{typo.name}</h3>
            <p className={`${typo.className}`}>{typo.example}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TypographySection;
